import React from 'react';
import { GameBrand } from '@precisionpros/game-ui';

export function FinderWordmark() {
  return <><span style={{ color: '#333', fontWeight: 500 }}>Word</span><span style={{ color: '#4CAF50', fontWeight: 900 }}>Pro</span><span style={{ color: '#333', fontWeight: 500 }}>Finder</span></>;
}

export default function SiteHeader({ title, action, children }) {
  return <header className="site-header">
    <div className="site-header-top">
      <a className="site-logo" href="/" aria-label="WordProFinder home"><GameBrand game={{ name: 'Word', wordmarkMain: 'Word', wordmarkAccent: 'Pro', wordmarkSuffix: 'Finder', badge: 'WF', accent: '#4CAF50' }} size="header" /></a>
      <h1>{title}</h1>
      {action}
    </div>
    <div className="site-header-links">{children}</div>
  </header>;
}
